import { createFileRoute } from "@tanstack/react-router";
import { configuratorRouteLoader } from "./-configuratorLoader";
import { ConfiguratorRoute } from "./-configuratorShared";

export const Route = createFileRoute("/$productCode/configuratorPage/LinearConfigurator")({
  loader: configuratorRouteLoader,
  component: ConfiguratorRoute,
});
